"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var bignumber_js_1 = require("bignumber.js");
var logs_1 = require("@ledgerhq/logs");
var errors_1 = require("@ledgerhq/errors");
var cache_1 = require("./cache");
var errors_2 = require("./errors");
var utils_1 = require("./wallet-btc/utils");
var factory_1 = __importDefault(require("./wallet-btc/crypto/factory"));
var base_1 = require("./wallet-btc/crypto/base");
var getTransactionStatus = function (a, t) { return __awaiter(void 0, void 0, void 0, function () {
    var errors, warnings, useAllAmount, _a, recipientError, recipientWarning, isTaproot, txInputs, txOutputs, estimatedFees, opReturnData, sumOfInputs, sumOfChanges, totalSpent, amount, txSize, crypto_1, dustAmount;
    return __generator(this, function (_b) {
        switch (_b.label) {
            case 0:
                errors = {};
                warnings = {};
                useAllAmount = !!t.useAllAmount;
                return [4 /*yield*/, (0, cache_1.validateRecipient)(a.currency, t.recipient)];
            case 1:
                _a = _b.sent(), recipientError = _a.recipientError, recipientWarning = _a.recipientWarning;
                if (recipientError) {
                    errors.recipient = recipientError;
                }
                if (recipientWarning) {
                    warnings.recipient = recipientWarning;
                }
                if (!(t.recipient &&
                    !errors.recipient &&
                    a.currency.id === "bitcoin" &&
                    a.blockHeight <= 709632)) return [3 /*break*/, 3];
                return [4 /*yield*/, (0, cache_1.isTaprootRecipient)(a.currency, t.recipient)];
            case 2:
                isTaproot = _b.sent();
                if (isTaproot) {
                    errors.recipient = new errors_2.TaprootNotActivated();
                }
                _b.label = 3;
            case 3:
                estimatedFees = new bignumber_js_1.BigNumber(0);
                opReturnData = t.opReturnData;
                if (!!t.feePerByte) return [3 /*break*/, 4];
                errors.feePerByte = new errors_1.FeeNotLoaded();
                return [3 /*break*/, 7];
            case 4:
                if (!t.feePerByte.eq(0)) return [3 /*break*/, 5];
                errors.feePerByte = new errors_1.FeeRequired();
                return [3 /*break*/, 7];
            case 5:
                if (!(t.recipient && !errors.recipient)) return [3 /*break*/, 7];
                return [4 /*yield*/, (0, cache_1.calculateFees)({
                        account: a,
                        transaction: t
                    }).then(function (res) {
                        txInputs = res.txInputs;
                        txOutputs = res.txOutputs;
                        estimatedFees = res.fees;
                    }, function (error) {
                        if (error.name === "NotEnoughBalance") {
                            errors.amount = error;
                        }
                        else if (error.name === "DustLimit") {
                            errors.dustLimit = error;
                        }
                        else {
                            throw error;
                        }
                    })];
            case 6:
                _b.sent();
                _b.label = 7;
            case 7:
                sumOfInputs = (txInputs || []).reduce(function (sum, input) { return sum.plus(input.value); }, new bignumber_js_1.BigNumber(0));
                sumOfChanges = (txOutputs || [])
                    .filter(function (o) { return o.isChange; })
                    .reduce(function (sum, output) { return sum.plus(output.value); }, new bignumber_js_1.BigNumber(0));
                if (txInputs) {
                    (0, logs_1.log)("bitcoin", "".concat(txInputs.length, " inputs, sum: ").concat(sumOfInputs.toString()));
                }
                if (txOutputs) {
                    (0, logs_1.log)("bitcoin", "".concat(txOutputs.length, " outputs, sum of changes: ").concat(sumOfChanges.toString()));
                }
                totalSpent = sumOfInputs.minus(sumOfChanges);
                amount = useAllAmount ? totalSpent.minus(estimatedFees) : t.amount;
                (0, logs_1.log)("bitcoin", "totalSpent ".concat(totalSpent.toString(), " amount ").concat(amount.toString()));
                if (!errors.amount && !amount.gt(0)) {
                    errors.amount = useAllAmount
                        ? new errors_1.NotEnoughBalance()
                        : new errors_1.AmountRequired();
                }
                if (amount.gt(0) && estimatedFees.times(10).gt(amount)) {
                    warnings.feeTooHigh = new errors_1.FeeTooHigh();
                }
                if (t.feePerByte) {
                    txSize = Math.ceil(estimatedFees.toNumber() / t.feePerByte.toNumber());
                    crypto_1 = (0, factory_1["default"])(a.currency.id);
                    dustAmount = (0, utils_1.computeDustAmount)(crypto_1, txSize);
                    if (amount.gt(0) && amount.lt(dustAmount)) {
                        errors.dustLimit = new errors_1.DustLimit();
                    }
                }
                if (opReturnData && opReturnData.length > base_1.OP_RETURN_DATA_SIZE_LIMIT) {
                    errors.opReturnSizeLimit = new errors_1.OpReturnDataSizeLimit();
                }
                return [2 /*return*/, {
                        errors: errors,
                        warnings: warnings,
                        estimatedFees: estimatedFees,
                        amount: amount,
                        opReturnData: opReturnData === null || opReturnData === void 0 ? void 0 : opReturnData.toString(),
                        totalSpent: totalSpent,
                        txInputs: txInputs,
                        txOutputs: txOutputs
                    }];
        }
    });
}); };
exports["default"] = getTransactionStatus;
//# sourceMappingURL=js-getTransactionStatus.js.map